import axios from 'axios'
import { configure } from './config';
import { Create_user } from './components/home/Create_user';

var endPoint = {
    backendUrl: configure.backendUrl,
    backendCognitoUrl: "https://q340zrn3dk.execute-api.us-west-2.amazonaws.com"
}
const ApiService = {
    fileStorage: function (request,headers) {
        try {
            return axios.post(`${endPoint.backendUrl}/file_data`, request, headers).then(res => {
                return res;
            })
        } catch (error) {
            console.log('error', error);
            return error;
        }
    },

    filterUsers: function (request,headers) {
        try {
            return axios.post(`${endPoint.backendUrl}/filterusers`, request, headers).then(res => {
                return res;
            })
        } catch (error) {
            console.log('error', error);
            return error;
        }
    },

    listUsers: function (request,headers) {
        try {
            return axios.post(`${endPoint.backendUrl}/listusers`, request, headers).then(res => {
                return res;
            })
        } catch (error) {
            console.log('error', error);
            return error;
        }
    },

    download: function (request,headers) {
        try {
            return axios.post(`${endPoint.backendUrl}/PreURLGen`, request, headers).then(res => {
                return res;
            })
        } catch (error) {
            console.log('error', error);
            return error;
        }
    },

    Create_user: function (request) {
        try {
            return axios.post(`${endPoint.backendUrl}/createuser`, request).then(res => {
                return res;
            })
        } catch (error) {
            console.log('error', error);
            return error;
        }
    },
    
     };



axios.interceptors.request.use(
    (req) => {
       return req;
    },
    (err) => {
       return Promise.reject(err);
    }
  );
  

  axios.interceptors.response.use((response) => {
    return response;
}
, function (error) {
    // Do something with response error
    var resp = null;
    if (error.response.status === 406) {
        resp = Promise.resolve(error.response);
    }
    else if(error.response.status === 401) {
        window.location.href = window.location.origin;
    }
    return resp
}
);




export default ApiService;